import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPolarisedGlasses = function SvgPolarisedGlasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.998 2.466V1M18.74 5.259l1.037-1.037M5.26 18.738l-1.037 1.037M2.466 11.998H1M21.53 11.998h1.466M5.26 5.259 4.223 4.222M18.193 14.197a6.586 6.586 0 1 0-7.661 4.224M14.198 17.864v3.666a1.466 1.466 0 0 0 2.933 0v-3.666M20.063 17.864v.293c0 1.724.51 3.409 1.467 4.843a8.732 8.732 0 0 0 1.466-4.843v-.293"
  })));
};

export { SvgPolarisedGlasses as default };
//# sourceMappingURL=polarised-glasses.svg.js.map
